const EightIncomeContent = `

Income from the manufacture of tea.

8. (1) Income derived from the sale of tea grown and manufactured by the seller in India shall be computed as if it were income derived from business, and forty per cent of such income shall be deemed to be income liable to tax.

(2) In computing such income an allowance shall be made in respect of the cost of planting bushes in replacement of bushes that have died or become permanently useless in an area already planted, if such area has not previously been abandoned [, and for the purpose of determining such cost, no deduction shall be made in respect of the amount of any subsidy which, under the provisions of clause (30) of section 10, is not includible in the total income

`;

export default EightIncomeContent;